import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

const Error401 = () => {


  return (

    <Card className="text-center">
      <CardBody className="p-5">
        <div className="display-1 text-200 fs-error">401</div>
        <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
          You do not have permission to view this page.
        </p>
        <hr />
        <p>
          Check your login credentials. If you think this is a mistake,
          <a href="mailto:info@crowdcatcher.co" className="ml-1">
            contact us
          </a>
          .
        </p>
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon="home" className="mr-2" />
          Take me home
        </Link>
      </CardBody>
    </Card>
  );
}

export default Error401;
